import CommonAlert from "@/components/CommonAlert";
import useBulkUETDS from "@/providers/hooks/useBulkUETDS";
import { useTrackingActions, useTrackingShowBulkRegisterDialog } from "@/stores/use-tracking-table";

function TrackingBulkRegisterDialog() {
    const showBulkRegisterDialog = useTrackingShowBulkRegisterDialog();
    const { handleBulkUETDS, isPending } = useBulkUETDS();

    const { updateShowBulkRegisterDialog } = useTrackingActions();
    const handleConfirm = async () => {
        if (isPending || !showBulkRegisterDialog) return;
        await handleBulkUETDS(showBulkRegisterDialog.ids);
        handleClose();
    };

    const handleClose = () => {
        updateShowBulkRegisterDialog(null);
    };

    return (
        <CommonAlert
            open={!!showBulkRegisterDialog}
            loading={isPending}
            description="confirmations.bulkUETDSRegister"
            color="primary"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                count: showBulkRegisterDialog?.ids.length || 0,
            }}
        ></CommonAlert>
    );
}

export default TrackingBulkRegisterDialog;
